import React, { useContext, useEffect } from 'react';
import { Context } from '../../store/context';
import { MenuItem, Select } from '@mui/material';

function FilterPoints() {
  const { loadMarkers, filter, setFilter } = useContext(Context);

  const handleChange = (event) => {
    setFilter(event.target.value);
  };

  useEffect(() => {
    loadMarkers(filter);
  }, [filter]);

  return (
    <Select
      sx={{
        width: '100%',
        position: 'relative',
        maxWidth: '290px',
        borderRadius: '24px',
        paddingLeft: '10px',
        height: '48px',
        margin: '0',
        background: '#1063AC',
        color: 'white',
        '@media(max-width:768px)': {
          maxWidth: '100%',
        },
        svg: {
          color: 'white',
          position: 'absolute',
          top: '50%',
          right: '20px',
          transform: 'translate(0, -50%)',
          pointerEvents: 'none',
          width: '19px',
          height: '19px',
        },
      }}
      IconComponent={() => {
        return (
          <>
            <svg
              width="25"
              height="15"
              viewBox="0 0 25 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.3007 4.27035L14.3554 14.2661C13.8548 14.7295 13.1998 14.9909 12.5172 15C12.1884 15.0004 11.8627 14.936 11.5589 14.8103C11.2551 14.6846 10.9792 14.5002 10.7471 14.2677L0.801849 4.27035C0.428419 3.93719 0.168581 3.49593 0.0586333 3.00821C-0.0513145 2.5205 -0.00588059 2.01067 0.188588 1.54997C0.37821 1.09277 0.698999 0.701709 1.11064 0.425932C1.52228 0.150155 2.00641 0.00197521 2.50218 2.82731e-07H22.4688C22.9642 -0.000234807 23.4486 0.146142 23.8607 0.420623C24.2728 0.695103 24.5941 1.08537 24.784 1.54208C24.9863 1.99288 25.0484 2.4939 24.9622 2.98032C24.8761 3.46673 24.6456 3.91613 24.3007 4.27035Z"
                fill="white"
              />
            </svg>
          </>
        );
      }}
      value={filter ?? 0}
      onChange={handleChange}
    >
      <MenuItem value={0}>Todos</MenuItem>
      <MenuItem value={10}>Punto Droop</MenuItem>
      <MenuItem value={20}>Aliado Autorizado</MenuItem>
    </Select>
  );
}

export default FilterPoints;
